import { EmpresaTreeViewService } from './../../../../employee/services/empresa-treeView.service';
import { AtributosService } from './../../../../company-view/services/atributos.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { MatDialog } from '@angular/material/dialog';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';
import { LeaveService } from 'app/modules/leave/services/leave.service';

@Component({
    selector: 'app-leave-list',
    templateUrl: './leave-list.component.html',
    styleUrls: ['./leave-list.component.scss'],
    standalone: false
})
export class LeaveListComponent implements OnInit {
    displayedColumns: any[];
    marcaOptionList: any[];
    public selectedRowIndex = 0;
    attributeList=[];
    public isFirstTime:boolean=true;
    constructor(
        public selectionService: SelectionGenericService,
        public dialog: MatDialog,
        private fileExportService: FileExportService,
        private sharedService: SharedService,
        private filterService: FilterService,
        private changeDetectorRefs: ChangeDetectorRef,
        private leaveService: LeaveService,
        private _atributosService: AtributosService,
        public empresaTreeViewService: EmpresaTreeViewService,
        private changeDetect: ChangeDetectorRef,
    ) {
        this.empresaTreeViewService.EmpId.subscribe((_res: any) => {
            if (_res > 0) {
             
                this.isFirstTime=true;
                this.loadAttributes(_res)
            }
        }); 
    }

    refreshDisplayColumns()
    {
        this.displayedColumns = [
            {
                name: 'Actions',
                column: 'action',
                show: true,
                isPermit: true,
                disabled: true,
            },
            {
                name: 'Marcas',
                column: 'marcas',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Empresa',
                column: 'empresa',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 1',
                column: 'nivel1',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 2',
                column: 'nivel2',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 3',
                column: 'nivel3',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 4',
                column: 'nivel4',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 5',
                column: 'nivel5',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Referencia',
                column: 'referencia',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Referencia de Baja',
                column: 'leaveRef',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Comentario de empresa',
                column: 'comEmpresa',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'NIF',
                column: 'nif',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Trabajador',
                column: 'trabajador',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Edad',
                column: 'edad',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Puesto',
                column: 'puesto',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Género',
                column: 'gender',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Teléfonos',
                column: 'phones',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Dirección',
                column: 'direccion',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Población',
                column: 'poblacion',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Provincia',
                column: 'provincia',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'CP',
                column: 'cp',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F. Antigüedad',
                column: 'fAntiguedad',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F. Fin Contrato',
                column: 'fFinContrato',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: '% Jornada',
                column: 'jornada',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Tipo',
                column: 'tipo',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F. Baja',
                column: 'fBaja',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F. Alta',
                column: 'fAlta',
                show: true,
                isPermit: true,
                disabled: false,
            },
              {
                name: 'LOPD',
                column: 'consentimiento',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Días',
                column: 'dias',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Días en periodo',
                column: 'diasPeriodo',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Aviso Baja',
                column: 'avisoBaja',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Días Aviso B.',
                column: 'diasAvisoBaja',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Aviso Alta',
                column: 'avisoAlta',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Días Aviso A.',
                column: 'diasAvisoAlta',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Médico',
                column: 'medico',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'NJ',
                column: 'nj',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Fecha NJ',
                column: 'fechaNJ',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Días NJ',
                column: 'diasNJ',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'FPA',
                column: 'fpa',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Días Previstos',
                column: 'diasPrevistos',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'PES',
                column: 'pes',
                show: true,
                isPermit: this.selectionService.selectionPermissions.HasPES,
                disabled: false,
            },
            {
                name: 'Código D.',
                column: 'codDiagnostico',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasDiagnosisMark,
                disabled: false,
            },
            {
                name: 'Diagnóstico',
                column: 'diagnostico',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasDiagnosisMark,
                disabled: false,
            },
            {
                name: 'Grupo D.',
                column: 'grupoDiagnostico',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasDiagnosisMark,
                disabled: false,
            },
            //
            {
                name: 'F. Pres. Insp.',
                column: 'ifpresentacion',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos405,
                disabled: false,
            },
            {
                name: 'Motivo Insp.',
                column: 'imotivo',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos405,
                disabled: false,
            },
            {
                name: 'F. Visita Insp.',
                column: 'ifvisita',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos405,
                disabled: false,
            },
            {
                name: 'F. Resp. Insp.',
                column: 'ifrespuesta',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos405,
                disabled: false,
            },
            {
                name: 'Respuesta Insp.',
                column: 'irespuesta',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos405,
                disabled: false,
            },
            {
                name: 'F. Recl. Insp.',
                column: 'freclamacionInsp',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos405,
                disabled: false,
            },
            {
                name: 'Obs. Insp.',
                column: 'obs',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos405,
                disabled: false,
            },
            //
            {
                name: 'Atributos',
                column: 'atributos',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Ultima Actuacion',
                column: 'ultimaactuacion',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Proxima Tarea',
                column: 'proximatarea',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[0].attributoName,
                column: 'tAttr1',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[1].attributoName,
                column: 'tAttr2',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[2].attributoName,
                column: 'tAttr3',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[3].attributoName,
                column: 'tAttr4',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[4].attributoName,
                column: 'tAttr5',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[5].attributoName,
                column: 'tAttr6',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[6].attributoName,
                column: 'tAttr7',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[7].attributoName,
                column: 'tAttr8',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[8].attributoName,
                column: 'tAttr9',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[9].attributoName,
                column: 'tAttr10',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[10].attributoName,
                column: 'tAttr11',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[11].attributoName,
                column: 'tAttr12',
                show: false,
                isPermit: true,
                disabled: false,
            },
        ];
        this.leaveService.leaveColumns=[];
        this.displayedColumns.forEach(element => {
            if(element.show && element.isPermit) {
                this.leaveService.leaveColumns.push(element.name)
            }
        });
    }
    ngAfterViewInit(): void {
        this.isFirstTime=true;
        this.changeDetect.detectChanges();
    }
   
    public ngOnInit(): any {
        this.loadAttributes(parseInt(localStorage.getItem('Empresa')))
        this.selectionService.setPermissionForContextMenu();
        
                this.filterService.selectedAttribute = [];

        this.marcaOptionList = [
            {
                text: 'Marca de empresa',
                className: 'lbl3',
                label: 'E',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'Marca de médico',
                className: 'lbl4',
                label: 'M',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'Marca de coordinador',
                className: 'lbl2',
                label: 'C',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'Marca de mutua',
                className: 'lbl8',
                label: 'U',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'Marca externa',
                className: 'lbl7',
                label: 'X',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'No citado por diagnóstico',
                className: 'lbl7',
                label: 'D',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'No citado por zona',
                className: 'lbl7',
                label: 'Z',
                isPermit:
                    this.selectionService.selectionPermissions
                        .HasMarcaExternalView,
            },
            {
                text: 'Marca de simulación',
                className: 'lbl7',
                label: 'S',
                isPermit: this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'Marca de salud mental',
                className: 'lbl7',
                label: 'L',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
        ];
    }

    toggleDisplayColumn(columnName, value): any {
        this.displayedColumns.filter((c) => c.column === columnName)[0].show =
            value;
            this.leaveService.leaveColumns=[];
            this.displayedColumns.forEach(element => {
                if(element.show) {
                    this.leaveService.leaveColumns.push(element.name)
                }
            });
    }

    getDisplayedColumns(): string[] {
        return this.displayedColumns
            .filter((cd) => cd.show && cd.isPermit)
            .map((cd) => cd.column);
    }

    public getLeaves(pageEvent: PageEvent): void {
        this.selectionService.SearchLeaves(
            pageEvent.pageIndex,
            pageEvent.pageSize,
            false
        );
    }

    public getLeaveRecord(row, event): any {
        const isExcept = event.target.classList.contains('except');
        if (!isExcept && this.selectionService.isShowLeavePanel) {
            this.selectedRowIndex = row.bajaId;
            this.selectionService.getLeaveRecord(row);
        }
    }

    public DownloadExcel(): any {
        if (this.selectionService.dataSource.data.length > 0) {
            this.fileExportService.exportDatasetToExcel(
                this.selectionService.dataSource.data,
                'Bajas-Selección'
            );
        } else {
            this.sharedService.ShowSnackBar(
                'La lista esta vacía',
                'Okay',
                2000
            );
        }
    }

    public DownloadWord(): any {
        if (this.selectionService.dataSource.data.length > 0) {
            this.fileExportService.exportWordDocument('Selection');
        } else {
            this.sharedService.ShowSnackBar(
                'La lista esta vacía',
                'Okay',
                2000
            );
        }
    }

    loadAttributes(empresaId)
    {
        this._atributosService.GetAttributoEmpresa(empresaId)
        .subscribe(res => {
        if (res.result) {
            this.attributeList=res.result;
            console.log(res.result)
            this.refreshDisplayColumns();
        }
        });
    }
    
    checkConsentimento(TipoConsentimiento,Consentimiento)
    {        
        if (TipoConsentimiento == 'EG')
        {
            return 'EG';
        }
        else if(TipoConsentimiento=='G')
        {
            return 'G'
        }
        else if(Consentimiento=='E')
        {
            return 'E'
        }
        else if(Consentimiento=='S' || TipoConsentimiento=='E')
        {
            return 'F'
        }else
        {
            return 'N'
        }
    }

    public toggleMarca(leaveRow: any, marca: any, checked: boolean): void {
        const index = this.selectionService.dataSource.data.indexOf(leaveRow);
        let marcaString = '';
        if (leaveRow.marcas !== null) {
            marcaString = String(leaveRow.marcas);
        }
        if (checked) {
            marcaString = marcaString.concat(marca.label);
        } else {
            marcaString = marcaString.replace(marca.label, '');
        }

        this.leaveService
            .UpdateLeaveMarca(leaveRow.bajaId, { marcas: marcaString })
            .subscribe(
                (res) => {
                    if (res.code === 0 && res.result) {
                        leaveRow.marcas = marcaString;
                        this.selectionService.dataSource.data.splice(
                            index,
                            1,
                            leaveRow
                        );
                        this.changeDetectorRefs.detectChanges();
                    }
                },
                (error) => {
                    this.sharedService.ShowSnackBar(
                        'Actualización de marca fallida',
                        'Okay',
                        2000
                    );
                    console.error(error);
                }
            );
    }
}
